import Flex from 'components/common/Flex';
import { useOAuth2 } from 'hooks/useOAuth2';
import { useEffect } from 'react';

/**
 * Componente de Login
 * Redireciona automaticamente para o servidor OAuth2 para iniciar o fluxo de autenticação
 */
const Login = () => {
  const { initiateLogin, error } = useOAuth2();

  useEffect(() => {
    initiateLogin();
  }, [initiateLogin]);

  if (error) {
    return (
      <Flex alignItems="center" justifyContent="center">
        <div className="text-center">
          <h1 className="text-danger">Erro ao iniciar login</h1>
          <p className="text-muted">{error}</p>
        </div>
      </Flex>
    );
  }

  return (
    <Flex alignItems="center" justifyContent="center">
      <h1>Carregando...</h1>
    </Flex>
  );
};

export default Login;
